/* eslint-disable no-bitwise */
import qs from "qs";
import { format } from "date-fns";

const objectToUrlParams = obj => qs.stringify(obj);

const pathJoin = (parts, sep = "/") => {
  const replace = new RegExp(`${sep}{1,}`, "g");

  return parts.join(sep).replace(replace, sep);
};

const urlParamsToObject = str => qs.parse(str);

const isValidDate = date =>
  // eslint-disable-next-line no-restricted-globals
  date instanceof Date && !isNaN(date);
const convertToDate = date => {
  if (date === null || date === undefined) return null;

  const dateInstance = new Date(date);
  if (isValidDate(dateInstance)) {
    return dateInstance;
  }

  return null;
};

const generateUniqueID = () => (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();

const getNoDataType = (count, isFiltersApplied) => {
  if (count === 0) {
    return isFiltersApplied ? "filters" : "noData";
  }
  return null;
};

const addDataToErrors = (errors, data) =>
  errors.map(error => {
    const newError = { ...error };
    if (newError.data) {
      newError.data = { ...newError.data, ...data };
    }
    return newError;
  });

const dateToStartOfDay = date => format(date, "yyyy-MM-dd'T'00:00:01.00+00:00");

const dateToEndOfDay = date => format(date, "yyyy-MM-dd'T'23:59:59.00+00:00");

const dateAdapter = data => {
  let newData = data;

  const date = new Date();
  const timeZoneOffsetInMinutes = date.getTimezoneOffset();
  const timeZoneOffsetHours = Math.abs(Math.floor(timeZoneOffsetInMinutes / 60));
  const timeZoneOffsetMinutes = Math.abs(timeZoneOffsetInMinutes % 60);
  const timeZoneOffsetSign = timeZoneOffsetInMinutes < 0 ? "+" : "-";
  const timeZone = `${timeZoneOffsetSign + timeZoneOffsetHours.toString().padStart(2, "0")}:${timeZoneOffsetMinutes
    .toString()
    .padStart(2, "0")}`;

  if (data?.to) {
    const toDate = new Date(data.to);
    const month = (toDate.getUTCMonth() + 1).toLocaleString("en", { minimumIntegerDigits: 2 });
    const day = toDate.getUTCDate().toLocaleString("en", { minimumIntegerDigits: 2 });
    newData = {
      ...newData,
      to: `${toDate.getUTCFullYear()}-${month}-${day}T23:59:59.999${timeZone}`
    };
  }
  if (data?.from) {
    const fromDate = new Date(data.from);
    const month = (fromDate.getUTCMonth() + 1).toLocaleString("en", { minimumIntegerDigits: 2 });
    const day = fromDate.getUTCDate().toLocaleString("en", { minimumIntegerDigits: 2 });

    newData = {
      ...newData,
      from: `${fromDate.getUTCFullYear()}-${month}-${day}T00:00:00.00${timeZone}`
    };
  }

  return newData;
};

const aggrSumByProps = (items, aggregateProperties, propertiesToSum) => {
  const aggregationResult = {};

  items.forEach(item => {
    const keyParts = [];

    aggregateProperties.forEach(prop => {
      if (prop in item) {
        keyParts.push(`${prop}:${item[prop]}`);
      } else {
        keyParts.push(`${prop}:missing-${prop}`);
      }
    });

    const resKey = keyParts.join("|");

    if (aggregationResult[resKey]) {
      propertiesToSum.forEach(prop => {
        aggregationResult[resKey][prop] += item[prop];
      });
    } else {
      aggregationResult[resKey] = { ...item };
      propertiesToSum.forEach(prop => {
        if (!(prop in item)) {
          aggregationResult[resKey][prop] = 0;
        }
      });
    }
  });

  return Object.values(aggregationResult);
};

const normalizeInvoiceIdCase = id =>
  id
    .split("-")
    .map((s, i) => (i === 0 ? s.toUpperCase() : s.toLowerCase()))
    .join("-");

export {
  objectToUrlParams,
  urlParamsToObject,
  convertToDate,
  isValidDate,
  pathJoin,
  generateUniqueID,
  getNoDataType,
  dateToStartOfDay,
  dateToEndOfDay,
  addDataToErrors,
  dateAdapter,
  aggrSumByProps,
  normalizeInvoiceIdCase
};
